import { Button as MuiButton } from '@mui/material';

export default MuiButton;
